export const SET_OLT = 'SET_OLT';

export function setOlt(olt) {
  return {
    type: SET_OLT,
    olt,
  };
}